import _taggedTemplateLiteral from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _createClass from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <style>\n      :host {\n        display: inline-block;\n        position: relative;\n        padding: 5px;\n        font-family: sans-serif;\n        width: 150px;\n        outline: none;\n      }\n    \n      :host(.pending) {\n        opacity: 0;\n      }\n    \n      :host(.disabled) {\n        opacity: 0.6 !important;\n        cursor: default;\n        pointer-events: none;\n      }\n    \n      :host(.disabled) svg {\n        background: rgba(0, 0, 0, 0.07);\n      }\n    \n      .overlay {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        pointer-events: none;\n      }\n    \n      svg {\n        display: block;\n      }\n    \n      path {\n        stroke: currentColor;\n        stroke-width: 0.7;\n        fill: transparent;\n      }\n    \n      input {\n        display: block;\n        width: 100%;\n        box-sizing: border-box;\n        outline: none;\n        border: none;\n        font-family: inherit;\n        font-size: inherit;\n        font-weight: inherit;\n        color: inherit;\n      }\n    </style>\n    <input id=\"txt\" name$=\"", "\" type$=\"", "\" placeholder$=\"", "\" disabled?=\"", "\" required?=\"", "\"\n      autocomplete$=\"", "\" autofocus?=\"", "\" minlength$=\"", "\" maxlength$=\"", "\" min$=\"", "\"\n      max$=\"", "\" step$=\"", "\" readonly?=\"", "\" size$=\"", "\" autocapitalize$=\"", "\" autocorrect$=\"", "\"\n      on-change=\"", "\">\n    <div class=\"overlay\">\n      <svg id=\"svg\"></svg>\n    </div>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { LitElement, html } from '@polymer/lit-element/lit-element.js';
import { wired } from 'wired-lib/wired-lib.js';
export var WiredInput =
/*#__PURE__*/
function (_LitElement) {
  _inherits(WiredInput, _LitElement);

  _createClass(WiredInput, null, [{
    key: "properties",
    get: function get() {
      return {
        placeholder: String,
        name: String,
        disabled: Boolean,
        type: String,
        required: Boolean,
        autocomplete: String,
        autofocus: Boolean,
        minlength: Number,
        maxlength: Number,
        min: String,
        max: String,
        step: String,
        readonly: Boolean,
        size: Number,
        autocapitalize: String,
        autocorrect: String,
        value: String
      };
    }
  }]);

  function WiredInput() {
    var _this;

    _classCallCheck(this, WiredInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WiredInput).call(this));
    _this.disabled = false;
    return _this;
  }

  _createClass(WiredInput, [{
    key: "_createRoot",
    value: function _createRoot() {
      var root = this.attachShadow({
        mode: 'open',
        delegatesFocus: true
      });
      this.classList.add('pending');
      return root;
    }
  }, {
    key: "_render",
    value: function _render(_ref) {
      var _this2 = this;

      var type = _ref.type,
          placeholder = _ref.placeholder,
          disabled = _ref.disabled,
          required = _ref.required,
          autocomplete = _ref.autocomplete,
          autofocus = _ref.autofocus,
          minlength = _ref.minlength,
          maxlength = _ref.maxlength,
          min = _ref.min,
          max = _ref.max,
          step = _ref.step,
          readonly = _ref.readonly,
          size = _ref.size,
          autocapitalize = _ref.autocapitalize,
          autocorrect = _ref.autocorrect,
          name = _ref.name;

      this._onDisableChange();

      return html(_templateObject(), name, type, placeholder, disabled, required, autocomplete, autofocus, minlength, maxlength, min, max, step, readonly, size, autocapitalize, autocorrect, function (e) {
        return _this2._onChange(e);
      });
    }
  }, {
    key: "_onDisableChange",
    value: function _onDisableChange() {
      if (this.disabled) {
        this.classList.add("disabled");
      } else {
        this.classList.remove("disabled");
      }
    }
  }, {
    key: "_onChange",
    value: function _onChange(event) {
      event.stopPropagation();
      var newEvent = new CustomEvent(event.type, {
        bubbles: true,
        composed: true,
        cancelable: event.cancelable,
        detail: {
          sourceEvent: event
        }
      });
      this.dispatchEvent(newEvent);
    }
  }, {
    key: "_clearNode",
    value: function _clearNode(node) {
      while (node.hasChildNodes()) {
        node.removeChild(node.lastChild);
      }
    }
  }, {
    key: "_didRender",
    value: function _didRender() {
      var svg = this.shadowRoot.getElementById('svg');

      this._clearNode(svg);

      var s = this.getBoundingClientRect();
      svg.setAttribute("width", s.width);
      svg.setAttribute("height", s.height);
      wired.rectangle(svg, 0, 0, s.width, s.height);
      this.classList.remove('pending');

      if (typeof this._value !== 'undefined') {
        this.input.value = this._value;
        delete this._value;
      }
    }
  }, {
    key: "input",
    get: function get() {
      return this.shadowRoot.getElementById('txt');
    }
  }, {
    key: "value",
    get: function get() {
      var input = this.input;
      return input && input.value || '';
    },
    set: function set(v) {
      if (this.shadowRoot) {
        var input = this.input;

        if (input) {
          input.value = v;
        }
      } else {
        this._value = v;
      }
    }
  }]);

  return WiredInput;
}(LitElement);
customElements.define('wired-input', WiredInput);